import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CheckboxControl } from '../../../controls/setup-wizard/checkbox-control/checkbox-control';

@Component({
	selector: 'app-checkbox-field',
	standalone: true,
	imports: [CheckboxControl],
	templateUrl: './checkbox-field.html',
})
export class CheckboxField {
	label = input.required<string>();
	controlName = input.required<string>();
	required = input<boolean>(false);
	formGroup = input.required<FormGroup>();
}
